// import external dependencies
import 'jquery';

// Import everything from autoload


// Webfonts
var WebFont = require('webfontloader');
WebFont.load({
  google: {
      families: ['Open+Sans:200,400,600'],
  },
});

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import audioPlayer from './routes/audioplayer';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  // Audio player
  audioPlayer,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js